<template>
  <b-container>
    <div class="body-wrapper">
      <div class="body-title">
        <b-row class="no-gutters">
          <b-col>
            <h5 class="dash-heading">Dashboard</h5>
          </b-col>
          <b-col style="text-align: right">
            <!-- <div  style="float:right;margin-top:-0.7rem"><span><small> Profile Completion:</small></span>
              <b-progress :max="max" class="w-75 float-right" style="background-color: #a0a3a7;">
                <b-progress-bar :value="counter">
                 <strong>{{ counter }} / {{ max }}</strong>
                </b-progress-bar>
              </b-progress>
            </div>-->
            <b-btn
              variant="secondary"
              v-if="isLoading2"
              size="sm"
              @click="submit"
              >Create Profile</b-btn
            >
            <Spinner size="16" message="Loading..." v-if="isLoading2"></Spinner>
          </b-col>
        </b-row>
      </div>
      <div class="body-content">
        <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
        <b-alert
          :show="showDismissibleAlert"
          dismissible
          @dismissed="showDismissibleAlert = false"
          :variant="variant"
          >{{ alertText }}</b-alert
        >
        <b-card class="mb-3" v-if="notices.length>0">
          <div v-for="notice in notices" :key="notice.Header">
            <h6 style="color:red">{{notice.Header}}</h6>
            <strong style="font-size:12px">{{notice.Subheader}}</strong>
            <p style="font-size:12px">{{notice.RejectRemarks}}</p>
            <p style="font-size:12px">Date: {{notice.RemarkDate}}</p>
            <b-button
              v-if="canOpenNoticeClaim(notice)"
              size="sm"
              variant="warning"
              class="mb-2"
              @click="openNoticeClaim(notice)"
            >Edit &amp; Re-send Claim</b-button>
          </div>
        </b-card>

        <!-- <b-table show-empty head-variant="dark"
                    empty-text="No Data available"
                      stacked="md"
                      bordered
                      striped
                      :items="PersonDataScheme"
                      :fields="PersonDatafields"
                      :current-page="currentPage"
                      :per-page="perPage"
                      :filter="filter"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      @filtered="onFiltered"
                      style="font-size:12px"

          >
              <template slot="details" slot-scope="row">
                   <b-button size="sm" @click.stop="showDetails(row.item, row.index, $event.target)"
                      class="mr-1 pt-0 pb-0" variant="outline-success" v-b-tooltip.hover title="View Details">
                      Details
                  </b-button>
                  <a :href="s3bucketpath(row.item)" target="_blank">View</a>
              </template>
              <template slot="action" slot-scope="row">
                   <b-button size="sm" @click.stop="applyforScheme(row.item, row.index, $event.target,4)"
                      class="mr-1 pt-0 pb-0" variant="outline-danger" v-b-tooltip.hover title="View Details">
                      View
                  </b-button>
              </template>
        </b-table>-->

        <h4 class="dash-sec-heading">Available Schemes</h4>

        <b-row class="mb-2 dash-table-2-row">
          <b-col md="4">
            <b-input-group>
              <b-form-input
                v-model="filter"
                placeholder="Type to Search"
                size="sm"
              />
              <b-input-group-append>
                <b-btn :disabled="!filter" @click="filter = ''" size="sm"
                  >Clear</b-btn
                >
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col></b-col>
          <b-col md="4">
            <b-form-group
              horizontal
              label="Sort"
              class="mb-0 sort-label"
              label-size="sm"
              label-cols="1"
            >
              <b-input-group>
                <b-form-select
                  v-model="sortBy"
                  :options="sortOptions"
                  size="sm"
                >
                  <option slot="first" :value="null">-- none --</option>
                </b-form-select>
                <b-input-group-append>
                  <b-form-select
                    :disabled="!sortBy"
                    v-model="sortDesc"
                    size="sm"
                  >
                    <option :value="false">Asc</option>
                    <option :value="true">Desc</option>
                  </b-form-select>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Main table element -->
        <b-table
          class="table-2"
          show-empty
          head-variant="dark"
          empty-text="No Schemes available at this time. Keep Looking this space for new schemes"
          stacked="md"
          bordered
          striped
          :items="schemes"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          @filtered="onFiltered"
          style="font-size: 12px"
        >
          <template v-slot:cell(details)="row">
            <!-- <b-button size="sm" @click.stop="showDetails(row.item, row.index, $event.target)"
                      class="mr-1 pt-0 pb-0" variant="outline-success" v-b-tooltip.hover title="View Details">
                      Details
            </b-button>-->
            <a :href="s3bucketpath(row.item)" target="_blank">View</a>
          </template>
          <template v-slot:cell(action)="row">
            <b-button
              size="sm"
              @click.stop="
                applyforScheme(row.item, row.index, $event.target, 1)
              "
              class="mr-1 pt-0 pb-0 color-btn"
              variant="outline-success"
              v-b-tooltip.hover
              title="Eligibility for the scheme"
              >Eligibility</b-button
            >
            <b-button
              size="sm"
              @click.stop="
                applyforScheme(row.item, row.index, $event.target, 2)
              "
              class="mr-1 pt-0 pb-0 color-btn"
              variant="outline-info"
              v-b-tooltip.hover
              title="Guidelines for Loan Scheme"
              >Guidelines</b-button
            >

            <b-button
              size="sm"
              @click.stop="
                applyforScheme(row.item, row.index, $event.target, 4)
              "
              class="mr-1 pt-0 pb-0 color-btn"
              variant="outline-danger"
              v-b-tooltip.hover
              title="View Details"
              >View</b-button
            >
            <b-button
              size="sm"
              @click.stop="
                applyforScheme(row.item, row.index, $event.target, 3)
              "
              class="mr-1 pt-0 pb-0 color-btn"
              variant="outline-danger"
              v-b-tooltip.hover
              title="Apply for the Scheme"
              >Apply</b-button
            >
          </template>
        </b-table>
        <b-row class="dash-pagination-row">
          <b-col md="8" class="my-1">
            <b-pagination
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
              class="my-0"
              size="sm"
            />
          </b-col>
          <b-col md="4" class="my-1">
            <b-form-group
              horizontal
              label="Per page"
              class="mb-0"
              label-size="sm"
              :label-cols="6"
            >
              <b-form-select
                :options="pageOptions"
                v-model="perPage"
                size="sm"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <div class="dash-divider"></div>
        <h4 class="dash-sec-heading">My Applications</h4>
        <table
          role="table"
          aria-busy="false"
          aria-colcount="4"
          class="
            table
            b-table
            table-striped table-bordered
            b-table-stacked-md
            dash-table-1
          "
          style="font-size: 12px"
        >
          <thead role="rowgroup" class="thead-dark">
            <tr role="row">
              <th role="columnheader">Application No.</th>
              <th role="columnheader">Application Date</th>
              <th role="columnheader">Scheme Type</th>
              <th role="columnheader">Status</th>
              <th role="columnheader">LOI</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="member in LoanApplication"
              :key="member.LoanApplicationNo"
            >
              <th
                v-if="
                  member.LoanApplicationNo !== undefined &&
                  member.LoanApplicationNo !== ''
                "
              >
                {{ member.LoanApplicationNo }}
              </th>
              <th
                v-if="
                  member.LoanApplicationNo !== undefined &&
                  member.LoanApplicationNo !== ''
                "
              >
                {{ member.Createdate }}
              </th>
              <th
                v-if="
                  member.LoanApplicationNo !== undefined &&
                  member.LoanApplicationNo !== ''
                "
              >
                <div v-if="member.LoanType == 1">Individual Loan</div>
                <div v-if="member.LoanType == 2">Group Loan</div>
                <div v-if="member.LoanType == 3">Education Loan</div>
              </th>
              <th
                v-if="
                  member.LoanApplicationNo !== undefined &&
                  member.LoanApplicationNo !== ''
                "
              >
                {{ member.LoanApplicationStatus }}
              </th>
              <th
                v-if="
                  member.LoanApplicationNo !== undefined &&
                  member.LoanApplicationNo !== ''
                "
              >
                <!-- <b-btn
                  variant="secondary"
                  size="sm"
                  class="dash-btn"
                  @click="submitBankDetails"
                >Submit Bank Details</b-btn>-->
                <b-btn
                  variant="secondary"
                  size="sm"
                  class="dash-btn"
                  @click="
                    downloadLOI(
                      member.LoanApplicationID,
                      member.LoanType,
                      member.UserID
                    )
                  "
                  v-if="
                   member.ApplicationStatus == 6 ||
                    member.ApplicationStatus == 16 ||
                    member.ApplicationStatus == 8 ||
                    member.ApplicationStatus == 21 ||
                    member.ApplicationStatus == 27
                  "
                  >DownLoad LOI</b-btn
                >
                <b-btn
                  variant="secondary"
                  size="sm"
                  class="dash-btn"
                  @click="
                    applytoExtendLOI(
                      member.LoanApplicationID,
                      member.LoanType,
                      member.UserID
                    )
                  "
                  v-if="member.ApplicationStatus == 10"
                  >Apply for Extension</b-btn
                >
              </th>
            </tr>
            <tr v-if="LoanApplication.length == 0">
              <th colspan="5" style="text-align: center">
                Not applied for any of the scheme yet.
              </th>
            </tr>
          </tbody>
        </table>

        <div class="dash-divider"></div>
        <h4 class="dash-sec-heading">My Profile</h4>
        <table
          role="table"
          aria-busy="false"
          aria-colcount="4"
          class="
            table
            b-table
            table-striped table-bordered
            b-table-stacked-md
            dash-table-1
          "
          style="font-size: 12px"
        >
          <thead role="rowgroup" class="thead-dark">
            <tr role="row">
              <th role="columnheader">Aadhar Id</th>
              <th role="columnheader">Applicant Name</th>
              <th role="columnheader">Mobile No.</th>
              <th role="columnheader">Profile Photo</th>
              <th role="columnheader">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>{{ AadharId }}</th>
              <th>{{ ApplicantName }}</th>
              <th>{{ MobileNo }}</th>
              <th>
                <img
                  style="width: 60px"
                  :src="getImgUrl(personalDetails.UserDocuments.PhotoPath)"
                />
              </th>
              <th>
                <b-btn
                  variant="secondary"
                  size="sm"
                  class="dash-btn"
                  @click="submitView"
                  >View Profile</b-btn
                >
                <b-btn
                  variant="warning"
                  size="sm"
                  class="dash-btn ml-1"
                  @click="openPersonalEditModal"
                  >Edit Personal Details</b-btn
                >
                <!-- Edit Lending Loan button hidden as per request
                <b-btn
                  variant="info"
                  size="sm"
                  class="dash-btn ml-1"
                  @click="openLendingLoanEditModal"
                  v-if="hasIndividualLoan"
                  >Edit Lending Loan</b-btn
                >
                -->

              </th>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- Edit Personal Details Modal -->
    <b-modal
      ref="editPersonalModal"
      size="lg"
      title="Edit Personal Details"
      @ok="savePersonalEditDash"
      ok-title="Save"
      cancel-title="Cancel"
    >
      <b-alert :show="modalAlert.show" :variant="modalAlert.variant" dismissible @dismissed="modalAlert.show=false">{{ modalAlert.text }}</b-alert>
      <b-form>
        <b-row>
          <b-col md="4">
            <b-form-group label="First Name*" label-size="sm"><b-form-input v-model="editPersonalForm.FirstName" size="sm"></b-form-input></b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Middle Name" label-size="sm"><b-form-input v-model="editPersonalForm.MiddleName" size="sm"></b-form-input></b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Last Name*" label-size="sm"><b-form-input v-model="editPersonalForm.LastName" size="sm"></b-form-input></b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <b-form-group label="Date Of Birth" label-size="sm">
              <date-picker v-model="editPersonalDOB" format="DD-MM-YYYY" lang="en" size="small"></date-picker>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Gender" label-size="sm">
              <b-form-radio-group v-model="editPersonalForm.Gender">
                <b-form-radio :value="true">Male</b-form-radio>
                <b-form-radio :value="false">Female</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Married Status" label-size="sm">
              <b-form-radio-group v-model="editPersonalForm.MaritalStatus">
                <b-form-radio :value="true">Married</b-form-radio>
                <b-form-radio :value="false">Unmarried</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <b-form-group label="Mobile No" label-size="sm"><b-form-input v-model="editPersonalForm.MobileNo" size="sm" type="number"></b-form-input></b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Email ID" label-size="sm"><b-form-input v-model="editPersonalForm.EmailID" size="sm" type="email"></b-form-input></b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Aadhar No" label-size="sm"><b-form-input v-model="editPersonalForm.AdharNo" size="sm" placeholder="12 digit"></b-form-input></b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <b-form-group label="PAN No" label-size="sm"><b-form-input v-model="editPersonalForm.PanCardNo" size="sm"></b-form-input></b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Ration Card No" label-size="sm"><b-form-input v-model="editPersonalForm.RationCardNo" size="sm"></b-form-input></b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Family Income (Rs)" label-size="sm"><b-form-input v-model="editPersonalForm.FamilyIncome" size="sm" type="number"></b-form-input></b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <b-form-group label="Caste" label-size="sm">
              <b-form-select v-model="editPersonalForm.CasteID" :options="Caste" value-field="CasteID" text-field="CasteName" size="sm"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Indian National" label-size="sm">
              <b-form-radio-group v-model="editPersonalForm.Nationality">
                <b-form-radio :value="true">Yes</b-form-radio>
                <b-form-radio :value="false">No</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Maharashtra Domicile" label-size="sm">
              <b-form-radio-group v-model="editPersonalForm.Domiciled">
                <b-form-radio :value="true">Yes</b-form-radio>
                <b-form-radio :value="false">No</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>

        <hr />
        <h6 class="text-primary">Address Details (Correspondence)</h6>
        <b-row>
          <b-col md="4">
            <b-form-group label="House No" label-size="sm">
              <b-form-input v-model="editAddressForm.CorrespondenceAddress.HouseNo" size="sm"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Building No" label-size="sm">
              <b-form-input v-model="editAddressForm.CorrespondenceAddress.BuildingNo" size="sm"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Street" label-size="sm">
              <b-form-input v-model="editAddressForm.CorrespondenceAddress.Street" size="sm"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <b-form-group label="Locality" label-size="sm">
              <b-form-input v-model="editAddressForm.CorrespondenceAddress.Locality" size="sm"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Landmark" label-size="sm">
              <b-form-input v-model="editAddressForm.CorrespondenceAddress.Landmark" size="sm"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Village" label-size="sm">
              <b-form-input v-model="editAddressForm.CorrespondenceAddress.Village" size="sm"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <b-form-group label="State" label-size="sm">
              <b-form-select v-model="editAddressForm.CorrespondenceAddress.StateID" :options="addrStates" value-field="StateID" text-field="StateName" size="sm" @change="onAddrStateChange">
                <template #first><b-form-select-option value="">-- Select State --</b-form-select-option></template>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="District" label-size="sm">
              <b-form-select v-model="editAddressForm.CorrespondenceAddress.DistrictID" :options="addrDistricts" value-field="DistID" text-field="DistName" size="sm" @change="onAddrDistrictChange">
                <template #first><b-form-select-option value="">-- Select District --</b-form-select-option></template>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Taluka" label-size="sm">
              <b-form-select v-model="editAddressForm.CorrespondenceAddress.TalukaID" :options="addrTalukas" value-field="TalukaID" text-field="TalukaName" size="sm">
                <template #first><b-form-select-option value="">-- Select Taluka --</b-form-select-option></template>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <b-form-group label="Post" label-size="sm">
              <b-form-input v-model="editAddressForm.CorrespondenceAddress.Post" size="sm"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Pincode" label-size="sm">
              <b-form-input v-model="editAddressForm.CorrespondenceAddress.Pincode" size="sm" type="number"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Residing Since (Year)" label-size="sm">
              <b-form-input v-model="editAddressForm.CorrespondenceAddress.ResidanceSince" size="sm" type="number"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>

    <!-- Edit Lending Loan Details Modal -->
    <b-modal
      ref="editLendingLoanModal"
      size="lg"
      title="Edit Lending Loan Details"
      @ok="saveLendingLoanEditDash"
      ok-title="Save"
      cancel-title="Cancel"
    >
      <b-alert :show="modalAlert.show" :variant="modalAlert.variant" dismissible @dismissed="modalAlert.show=false">{{ modalAlert.text }}</b-alert>
      <b-form>
        <b-row>
          <b-col md="6">
            <b-form-group label="Organization / Institute Name" label-size="sm"><b-form-input v-model="editLendingLoanForm.UserLendingLoanDetails.OrganizationName" size="sm"></b-form-input></b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Organization / Institute Address" label-size="sm"><b-form-input v-model="editLendingLoanForm.UserLendingLoanDetails.OrganizationAddress" size="sm"></b-form-input></b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group label="Product / Course Name" label-size="sm"><b-form-input v-model="editLendingLoanForm.UserLendingLoanDetails.ProductfromOrganization" size="sm"></b-form-input></b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Amount From Bank (Rs)" label-size="sm"><b-form-input v-model="editLendingLoanForm.UserLendingLoanDetails.AmountFromBank" size="sm" type="number"></b-form-input></b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group label="Bank Name" label-size="sm"><b-form-input v-model="editLendingLoanForm.UserLendingLoanDetails.BankName" size="sm"></b-form-input></b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Branch" label-size="sm"><b-form-input v-model="editLendingLoanForm.UserLendingLoanDetails.Branch" size="sm"></b-form-input></b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>

    <b-modal
      ref="myModalRef"
      id="modal1"
      :title="title"
      size="lg"
      scrollable
      ok-only
    >
      <SchemeEligibility
        :SchemeID="selectedSchemeId"
        v-if="btnType == 1"
      ></SchemeEligibility>
      <SchemeGuidelines
        :SchemeID="selectedSchemeId"
        v-if="btnType == 2"
      ></SchemeGuidelines>
    </b-modal>
    <b-modal
      ref="confirmApply"
      id="modalConfirm"
      centered
      hide-footer
      title="Incomplete Profile"
      size="sm"
    >
      <p>To view for this scheme, you need to complete your profile</p>
      <hr />
      <div class="justify-content-md-center">
        <b-btn class="float-right" size="sm" variat="info" to="/LoginProfile"
          >Create Profile</b-btn
        >
      </div>
      <div class="justify-content-md-center">
        <b-btn variant="link" size="sm" class="float-right" @click="hideModal"
          >Cancel</b-btn
        >
      </div>
    </b-modal>
    <b-modal
      ref="confirmApply"
      id="modalConfirm1"
      centered
      hide-footer
      title="Application Number"
      size="sm"
    >
      <p v-if="isViewEnabledP == true">
        Your Application Number is : {{ AckPNo }}
      </p>
      <hr />
      <div class="justify-content-md-center">
        <b-btn variant="link" size="sm" class="float-right" @click="hideModal"
          >Cancel</b-btn
        >
      </div>
    </b-modal>
    <b-modal
      ref="confirmApply"
      id="modalConfirm2"
      centered
      hide-footer
      title="Application Number"
      size="sm"
    >
      <p v-if="isViewEnabledG == true">
        Your Application Number is : {{ AckGNo }}
      </p>
      <hr />
      <div class="justify-content-md-center">
        <b-btn variant="link" size="sm" class="float-right" @click="hideModal"
          >Cancel</b-btn
        >
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import apis from "../apis";
import Spinner from "vue-simple-spinner";
import DatePicker from "vue2-datepicker";
import Formatter from "@/Formatter.js";
import SchemeEligibility from "@/components/SchemeDetails/SchemeEligibility";
import SchemeGuidelines from "@/components/SchemeDetails/SchemeGuidelines";
export default {
  components: { Spinner, DatePicker, SchemeEligibility, SchemeGuidelines },
  data() {
    return {
      notices: [],
      personalDetails: {
        UserDocuments: {
          PhotoPath: null,
          SignaturePath: null,
          AdharCardPath: null,
          PancardPath: null,
          RationCardPath: null,
          CasteCertificate: null,
          EduCertificate: null,
          ExServiceManProof: null,
          ExprienceCertificate: null,
          BirthCertificate: null,
          PoliceVerification: null,
          MedicalCertificate: null,
          RecommendationLetter: null,
          DeceasedID: null,
          LegalHireNOC: null,
          FinalDuesLetter: null,
          CourtOrder: null,
        },
      },
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: true,
      isLoading2: false,
      AadharId: "",
      ApplicantName: "",
      MobileNo: "",
      ProfilePhoto: "",
      LoanApplication: [],
      //   {
      //     LoanType: "",
      //     UserID: "",
      //     LoanApplicationID: "",
      //     LoanApplicationNo: "",
      //     SchemeType: "",
      //     GroupID: "",
      //     AmountDemanded: "",
      //     ApplicationStatus: "",
      //     AmountApproved: "",
      //     Level1Approver: "",
      //     Level1ApprovalDate: "",
      //     Level2Approver: "",
      //     Level2ApprovalDate: "",
      //     LOIDate: "",
      //     BankID: "",
      //     BankApprovalDate: "",
      //     BankLoanAmount: "",
      //     BankInterestRate: "",
      //     LoanTenure: "",
      //     LoanStartDate: "",
      //     LoanEndDate: "",
      //     LoanStatus: ""
      //   }
      // ],
      PersonDataScheme: [
        {
          SchemeID: "",
          SchemeName: "Interest Refund",
          SchemeShortName: "IR-1",
          SchemeDescription: "",
          SchemePhoto: "",
          ApplyStatus: false,
        },
      ],
      schemes: [
        {
          SchemeID: "",
          SchemeName: "Interest Refund",
          SchemeShortName: "IR-1",
          SchemeDescription: "",
          ApplyStatus: false,
          LoanType: 1,
        },
      ],
      itemsa: [],
      counter: 0,
      max: 0,
      isIndivisual: false,
      isGroup: false,
      fields: [
        { key: "SchemeShortName", label: "Scheme ID", sortable: true },
        { key: "SchemeName", label: "Scheme Name", sortable: true },
        { key: "SchemeDescription", label: "Description", sortable: true },
        { key: "action", label: "Apply" },
      ],
      PersonDatafields: [
        { key: "AdharNo", label: "Aadhar ID", sortable: true },
        { key: "EmailID", label: "Email Address", sortable: true },
        { key: "Mobile", label: "Mobile No.", sortable: true },
        { key: "SchemePhoto", label: "Profile Photo", sortable: true },
        { key: "action", label: "Apply" },
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [5, 10, 15, 20, 50],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: "",
      selectedSchemeId: "00000000-0000-0000-0000-000000000000",
      selectedLoanType: 0,
      btnType: 1,
      title: "Scheme Eligibility",
      isApplyEnable: false,
      isViewEnabled: false,
      isViewEnabledP: false,
      isViewEnabledG: false,
      AckPNo: 0,
      AckGNo: 0,
      hasIndividualLoan: false,
      fullPersonalDetails: null,
      fullCorrespondenceAddress: null,
      Caste: [],
      modalAlert: { show: false, text: "", variant: "success" },
      editPersonalForm: {
        LoginID: "",
        FirstName: "",
        MiddleName: "",
        LastName: "",
        Gender: true,
        DOB: null,
        Age: 0,
        MobileNo: "",
        EmailID: "",
        AdharNo: "",
        PanCardNo: "",
        MaritalStatus: false,
        Nationality: true,
        Domiciled: true,
        CasteID: "",
        FamilyIncome: 0,
        RationCardNo: "",
        RegistrationType: 1,
      },
      editPersonalDOB: null,
      editAddressForm: {
        LoginID: "",
        CorrespondenceAddress: {
          StateID: "",
          DistrictID: "",
          TalukaID: "",
          HouseNo: "",
          BuildingNo: "",
          Street: "",
          Locality: "",
          Landmark: "",
          Village: "",
          Post: "",
          Pincode: "",
          ResidanceSince: "",
        },
        PermanentAddress: {},
        UserEmergencyContact: {},
      },
      addrStates: [],
      addrDistricts: [],
      addrTalukas: [],
      editLendingLoanForm: {
        LoginID: "",
        UserLendingLoanDetails: {
          OrganizationName: "",
          ProductfromOrganization: "",
          OrganizationAddress: "",
          AmountFromBank: "",
          LoanDistrict: "",
          BankName: "",
          Branch: "",
        },
      },
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    getRegTyp() {
      let x = this.$store.getters.getRegTyp;
      //console.log (x);
      return x;
    },
  },
  methods: {
    getApiErrorText(error, fallbackText) {
      const fallback = fallbackText || "Unable to save changes.";
      if (!error) return fallback;

      if (typeof error === "string" && error.trim()) return error;
      if (error.message && typeof error.message === "string" && error.message.trim()) return error.message;

      const body = error.body;
      if (typeof body === "string" && body.trim()) return body;
      if (body && typeof body === "object") {
        const bodyMessage = body.message || body.Message || body.error_description || body.error || body.title;
        if (typeof bodyMessage === "string" && bodyMessage.trim()) return bodyMessage;
      }

      if (typeof error.bodyText === "string" && error.bodyText.trim()) return error.bodyText;
      if (typeof error.statusText === "string" && error.statusText.trim() && error.statusText.toLowerCase() !== "error") return error.statusText;
      if (error.status) return "Request failed with status " + error.status;

      return fallback;
    },

    s3bucketpath(rowdtl) {
      return (
        "https://aws.msobcfdc.in/S3BucketApril/" +
        rowdtl.SchemeID +
        "/schemeinfo.pdf"
      );
    },
    getImgUrl(pic) {
      let userinfo = this.$store.getters.loggedUser;
      let userId = userinfo.UserId;
      if (pic) {
        return (
          "https://aws.msobcfdc.in/S3BucketApril/" +
          userId +
          "/" +
          pic
        );
      }
    },
    showTitleDialog() {
      this.$modal.show("dialog", {
        title: "Information",
        text: "Check out, I have a title 😎",
      });
    },
    info(item, index, button) {
      this.modalInfo.title = `Row index: ${index}`;
      this.modalInfo.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    applyforScheme(item, index, button, n) {
      this.selectedSchemeId = item.SchemeID;
      this.selectedLoanType = item.LoanType;
      this.$store.dispatch("setScheme", {
        SchemeID: this.selectedSchemeId,
        LoanType: this.selectedLoanType,
      });
      this.btnType = n;
      if (n == 1) {
        this.title = "Scheme Eligibility";
        this.$root.$emit("bv::show::modal", "modal1", button);
      } else if (n == 2) {
        this.title = "Scheme Guidelines";
        this.$root.$emit("bv::show::modal", "modal1", button);
      } else if (n == 3) {
        if (this.isViewEnabledP == true && item.LoanType == 1) {
          this.$root.$emit("bv::show::modal", "modalConfirm1");
        } else if (this.isViewEnabledG == true && item.LoanType == 2) {
          this.$root.$emit("bv::show::modal", "modalConfirm2");
        } else {
          this.$router.push("/LoginProfile");
        }
        //   let info = "You want to delete record for:" + "\n" + item.Document;
        // this.modalInfo = info;
      } else if (n == 4) {
        if (this.isViewEnabledG == false) {
          this.$root.$emit("bv::show::modal", "modalConfirm");
        } else {
          if (item.LoanType == 2) {
            this.$router.push("/ViewGroupDetails");
          }
        }
        if (this.isViewEnabledP == false) {
          this.$root.$emit("bv::show::modal", "modalConfirm");
        } else {
          if (item.LoanType == 1) {
            this.$router.push("/ViewPresonalDetails");
          }
        }
      }
    },
    submit() {
      this.isLoading2 = true;
      this.$router.push("/profile");
    },
    submitBankDetails() {
      this.isLoading2 = true;
      this.$router.push("/BankDetails");
    },
    downloadLOI(ApplicationID, LoanType, UserID) {
      this.isLoading2 = true;
      // member.UserID is often empty GUID for group loans. Fall back to the
      // logged-in user's ID so LoanLOIPrint can fetch group/profile data.
      var emptyGuid = "00000000-0000-0000-0000-000000000000";
      if (!UserID || UserID === emptyGuid) {
        var lu = this.$store.getters.loggedUser || {};
        UserID = lu.UserId || lu.UserID || UserID;
      }
      this.$router.push({
        name: "LoanLOIPrint",
        query: {
          ApplicationID: ApplicationID,
          Loantype: LoanType,
          UserID: UserID,
        },
      });
    },
    applytoExtendLOI(ApplicationID, LoanType, UserID) {
      this.isLoading2 = true;
      var userinfo = this.$store.getters.loggedUser;
      UserID = userinfo.UserId;

      var application = {
        ApplicationStatus: 0,
        RejectReason: 0,
        Remarks: "",
        UserID: UserID,
        ApplicationID: ApplicationID,
      };

      this.$dialog
        .prompt({
          title: "Confirm LOI Extension",
          body: "You are requesting for Extending LOI Due Date, Do you want to Continue?",
        })
        .then(function (dialog) {
          return apis.ApplyforExtension(application);
        })
        .then((response) => {
          if (response != undefined) {
            if (response.status == 200) {
              this.$dialog.alert(
                "Your Request is Submitted Successfully. Please wait for further information."
              );
              this.getApplicationsSub();
            } else {
              this.$dialog.alert("Unable to save changes");
            }
          }
        })
        .catch((err) => {
          alert('Hi'+err);
          if (err != false) {

            this.$dialog.alert("Error while saving data");
          }
        });

      Promise.then((response) => {}).catch((err) => {});
    },
    submitView() {
      this.isLoading2 = true;
      this.$router.push("/ViewPersonalprofile");
    },
    hideModal() {
      this.$refs.confirmApply.hide();
    },
    getProfileStatus() {
      var userinfo = this.$store.getters.loggedUser;
      let promiseU = apis.ReadUsePrfileStatus(userinfo.UserId);

      promiseU
        .then((response) => {
          if (response.status == 200) {
            //Check the profile completion status
            let rspns = response.body;

            for (var x in rspns) {
              if (x != "ProfileNumber") {
                if (
                  (this.getRegTyp == 0 &&
                    x != "ExprienceDetail" &&
                    x != "PaymentStatus") ||
                  (this.getRegTyp == 3 && x != "ExprienceDetail") ||
                  this.getRegTyp == 1 ||
                  this.getRegTyp == 2 ||
                  this.getRegTyp >= 4
                ) {
                  this.max++;

                  if (rspns[x]) {
                    this.counter++;
                  }
                }
              }
            }
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch((err) => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    getApplicationsSub() {
      this.isLoading = true;
      this.showDismissibleAlert = false;

      if (this.form.ApplicationStatusID == 2) {
        this.showsts = true;
      } else {
        this.showsts = false;
      }

      if (this.form.ApplicationStatusID == 1) {
        this.showbtn = true;
      } else {
        this.showbtn = false;
      }

      this.$store.dispatch("setSearchForm", this.form);
      let promise = apis.ReadApplicationList(this.form);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.applications = response.body;
            this.totalRows = this.applications.length;
            var userinfo = this.$store.getters.loggedUser;
            // if (this.form.ApplicationStatusID == 10 && userinfo.RoleID == 4) {
            //   this.showExtend = true;
            // } else {
            //   this.showExtend = false;
            // }
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });

      this.$refs.mdlAdvSearch.hide();
      //console.log(this.selectedDistrict);
    },
    async openPersonalEditModal() {
      if (!this.fullPersonalDetails) {
        this.alertText = "Profile data not loaded yet, please wait.";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        return;
      }
      const p = this.fullPersonalDetails;
      const userinfo = this.$store.getters.loggedUser;
      const ZERO_GUID = "00000000-0000-0000-0000-000000000000";
      // p.UserID can be the zero GUID (truthy but invalid) — always prefer store UserId
      const loginId = (p.UserID && p.UserID !== ZERO_GUID) ? p.UserID : userinfo.UserId;

      // --- Personal fields ---
      this.editPersonalForm.LoginID = loginId;
      this.editPersonalForm.FirstName = p.FirstName || "";
      this.editPersonalForm.MiddleName = p.MiddleName || "";
      this.editPersonalForm.LastName = p.LastName || "";
      this.editPersonalForm.Gender = p.Gender;
      this.editPersonalForm.MobileNo = p.MobileNo || "";
      this.editPersonalForm.EmailID = p.EmailID || "";
      this.editPersonalForm.AdharNo = p.AdharNo || "";
      this.editPersonalForm.PanCardNo = p.PanCardNo || "";
      this.editPersonalForm.MaritalStatus = p.MaritalStatus;
      this.editPersonalForm.Nationality = p.Nationality;
      this.editPersonalForm.Domiciled = p.Domiciled;
      this.editPersonalForm.FamilyIncome = p.FamilyIncome || 0;
      this.editPersonalForm.RationCardNo = p.RationCardNo || "";
      this.editPersonalForm.RegistrationType = p.RegistrationType || 1;
      if (p.CasteName && this.Caste.length > 0) {
        let c = this.Caste.find(x => x.CasteName === p.CasteName);
        this.editPersonalForm.CasteID = c ? c.CasteID : "";
      }
      this.editPersonalDOB = p.DOB ? Formatter.convertDateFormatYMD(p.DOB) : null;

      // --- AWAIT the full address fetch before showing modal ---
      // This guarantees fullCorrespondenceAddress is populated when Save is clicked.
      this.fullCorrespondenceAddress = null;
      try {
        const r = await apis.ReadLoanUseCorrespondanceAddress(loginId);
        if (r.status == 200 && r.body) {
          this.fullCorrespondenceAddress = r.body;
        }
      } catch (e) { /* non-fatal – fallback used in save */ }

      // Pre-fill address form from the authoritative fetched address (or fallback)
      const addr = this.fullCorrespondenceAddress || p.CorrespondenceAddress || {};
      this.editAddressForm.LoginID = loginId;
      this.editAddressForm.CorrespondenceAddress.HouseNo       = addr.HouseNo || "";
      this.editAddressForm.CorrespondenceAddress.BuildingNo    = addr.BuildingNo || "";
      this.editAddressForm.CorrespondenceAddress.Street        = addr.Street || "";
      this.editAddressForm.CorrespondenceAddress.Locality      = addr.Locality || "";
      this.editAddressForm.CorrespondenceAddress.Landmark      = addr.Landmark || "";
      this.editAddressForm.CorrespondenceAddress.Village       = addr.Village || "";
      this.editAddressForm.CorrespondenceAddress.Post          = addr.Post || "";
      this.editAddressForm.CorrespondenceAddress.Pincode       = addr.Pincode || "";
      this.editAddressForm.CorrespondenceAddress.ResidanceSince = addr.ResidanceSince || "";
      this.editAddressForm.CorrespondenceAddress.StateID       = addr.StateID || "";
      this.editAddressForm.CorrespondenceAddress.DistrictID    = addr.DistrictID || "";
      this.editAddressForm.CorrespondenceAddress.TalukaID      = addr.TalukaID || "";

      // Pre-load districts & talukas for already-selected values
      if (addr.StateID) {
        apis.getDistricts(addr.StateID).then(r => {
          if (r.status == 200) {
            this.addrDistricts = r.body;
            if (addr.DistrictID) {
              apis.getTaluka(addr.DistrictID).then(r2 => {
                if (r2.status == 200) this.addrTalukas = r2.body;
              }).catch(() => {});
            }
          }
        }).catch(() => {});
      } else {
        this.addrDistricts = [];
        this.addrTalukas = [];
      }
      this.modalAlert.show = false;
      this.$refs["editPersonalModal"].show();
    },

    savePersonalEditDash(bvModalEvt) {
      bvModalEvt.preventDefault();
      const realUserId = this.$store.getters.loggedUser.UserId;

      // --- Personal payload ---
      // Base = full loaded profile (keeps all nested server-required fields intact).
      // Overlay only the fields the user can edit.
      const personalPayload = JSON.parse(JSON.stringify(this.fullPersonalDetails));
      personalPayload.LoginID       = realUserId;
      personalPayload.FirstName     = this.editPersonalForm.FirstName;
      personalPayload.MiddleName    = this.editPersonalForm.MiddleName;
      personalPayload.LastName      = this.editPersonalForm.LastName;
      personalPayload.Gender        = this.editPersonalForm.Gender;
      personalPayload.DOB           = this.editPersonalDOB ? Formatter.convertDateFormatYMD(this.editPersonalDOB) : personalPayload.DOB;
      personalPayload.MobileNo      = this.editPersonalForm.MobileNo;
      personalPayload.EmailID       = this.editPersonalForm.EmailID;
      personalPayload.AdharNo       = this.editPersonalForm.AdharNo;
      personalPayload.PanCardNo     = this.editPersonalForm.PanCardNo;
      personalPayload.MaritalStatus = this.editPersonalForm.MaritalStatus;
      personalPayload.Nationality   = this.editPersonalForm.Nationality;
      personalPayload.Domiciled     = this.editPersonalForm.Domiciled;
      personalPayload.FamilyIncome  = this.editPersonalForm.FamilyIncome;
      personalPayload.RationCardNo  = this.editPersonalForm.RationCardNo;
      if (this.editPersonalForm.CasteID) personalPayload.CasteID = this.editPersonalForm.CasteID;
      personalPayload.LockProfile   = false;
      // Only turn truly empty string GUID fields into null.
      // Do NOT convert zero GUIDs — the server uses "00000000…" to mean "no record",
      // and converting them to null causes its own validation errors.
      const nullifyEmptyStrGuids = (obj) => {
        if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return;
        Object.keys(obj).forEach(k => {
          if (obj[k] === '' && (k.endsWith('ID') || k.endsWith('Id'))) {
            obj[k] = null;
          } else if (obj[k] && typeof obj[k] === 'object') {
            nullifyEmptyStrGuids(obj[k]);
          }
        });
      };
      nullifyEmptyStrGuids(personalPayload);
      // Re-assert realUserId after nullification (LoginID may have been cleared if it was empty)
      personalPayload.LoginID = realUserId;

      // --- Address payload ---
      // Base = exact object the server returned via ReadLoanUseCorrespondanceAddress.
      // Overlay only the fields visible in the modal.
      const fullAddr = this.fullCorrespondenceAddress
        ? JSON.parse(JSON.stringify(this.fullCorrespondenceAddress))
        : (this.fullPersonalDetails && this.fullPersonalDetails.CorrespondenceAddress)
          ? JSON.parse(JSON.stringify(this.fullPersonalDetails.CorrespondenceAddress))
          : { PanCard: true, HandiCap: false, Nationality: "Indian" };

      if (fullAddr.PanCard   === undefined) fullAddr.PanCard   = true;
      if (fullAddr.HandiCap  === undefined) fullAddr.HandiCap  = false;
      if (!fullAddr.Nationality)            fullAddr.Nationality = "Indian";

      const editedAddr = this.editAddressForm.CorrespondenceAddress;
      fullAddr.HouseNo       = editedAddr.HouseNo       || null;
      fullAddr.BuildingNo    = editedAddr.BuildingNo    || null;
      fullAddr.Street        = editedAddr.Street        || null;
      fullAddr.Locality      = editedAddr.Locality      || null;
      fullAddr.Landmark      = editedAddr.Landmark      || null;
      fullAddr.Village       = editedAddr.Village       || null;
      fullAddr.Post          = editedAddr.Post          || null;
      fullAddr.Pincode       = editedAddr.Pincode       ? parseInt(editedAddr.Pincode)   : null;
      // ResidanceSince is int? on the server — empty string must become null
      fullAddr.ResidanceSince = editedAddr.ResidanceSince ? parseInt(editedAddr.ResidanceSince) : null;
      if (editedAddr.StateID)    fullAddr.StateID    = editedAddr.StateID;
      if (editedAddr.DistrictID) fullAddr.DistrictID = editedAddr.DistrictID;
      if (editedAddr.TalukaID)   fullAddr.TalukaID   = editedAddr.TalukaID;
      // Remove read-only display fields the server returns but must not receive back
      delete fullAddr.StateName;
      delete fullAddr.DistrictName;
      delete fullAddr.TalukaName;

      const addrPayload = {
        LoginID: realUserId,
        CorrespondenceAddress: fullAddr,
        PermanentAddress: null,
        UserEmergencyContact: null,
      };

      console.log("[UserRegistration] LoginID:", personalPayload.LoginID);
      console.log("[LoanUserAddress] payload:", JSON.stringify(addrPayload));
      let promise = apis.saveUserRegistration(personalPayload);
      let promiseAddr = apis.saveLoanUserAddress(addrPayload);
      Promise.all([promise, promiseAddr]).then(([response]) => {
        if (response.status == 200) {
          if (this.fullPersonalDetails) {
            this.fullPersonalDetails.FirstName = this.editPersonalForm.FirstName;
            this.fullPersonalDetails.MiddleName = this.editPersonalForm.MiddleName;
            this.fullPersonalDetails.LastName = this.editPersonalForm.LastName;
            this.fullPersonalDetails.MobileNo = this.editPersonalForm.MobileNo;
            this.fullPersonalDetails.EmailID = this.editPersonalForm.EmailID;
            this.fullPersonalDetails.AdharNo = this.editPersonalForm.AdharNo;
          }
          this.AadharId = this.editPersonalForm.AdharNo;
          this.MobileNo = this.editPersonalForm.MobileNo;
          this.ApplicantName = [this.editPersonalForm.FirstName, this.editPersonalForm.MiddleName, this.editPersonalForm.LastName].filter(Boolean).join(' ');
          this.alertText = "Personal Details & Address Updated Successfully";
          this.variant = "success";
          this.showDismissibleAlert = true;
          this.$refs["editPersonalModal"].hide();
        } else {
          this.modalAlert = { show: true, text: "Error: " + this.getApiErrorText(response, "Unable to update personal details."), variant: "danger" };
        }
      }).catch((err) => {
        this.modalAlert = { show: true, text: "Error: " + this.getApiErrorText(err, "Unable to update personal details."), variant: "danger" };
      });
    },

    openLendingLoanEditModal() {
      var userinfo = this.$store.getters.loggedUser;
      let promise = apis.ReadUserLendingLoanDetails(userinfo.UserId);
      promise.then((response) => {
        if (response.status == 200) {
          const l = response.body || {};
          this.editLendingLoanForm.LoginID = userinfo.UserId;
          this.editLendingLoanForm.UserLendingLoanDetails.OrganizationName = l.OrganizationName || "";
          this.editLendingLoanForm.UserLendingLoanDetails.OrganizationAddress = l.OrganizationAddress || "";
          this.editLendingLoanForm.UserLendingLoanDetails.ProductfromOrganization = l.ProductfromOrganization || "";
          this.editLendingLoanForm.UserLendingLoanDetails.AmountFromBank = l.AmountFromBank || "";
          this.editLendingLoanForm.UserLendingLoanDetails.LoanDistrict = l.LoanDistrict || "";
          this.editLendingLoanForm.UserLendingLoanDetails.BankName = l.BankName || "";
          this.editLendingLoanForm.UserLendingLoanDetails.Branch = l.Branch || "";
          this.modalAlert.show = false;
          this.$refs["editLendingLoanModal"].show();
        } else {
          this.alertText = "Could not load lending loan details.";
          this.variant = "warning";
          this.showDismissibleAlert = true;
        }
      }).catch((err) => {
        this.alertText = "Error: " + this.getApiErrorText(err, "Unable to load lending loan details.");
        this.variant = "danger";
        this.showDismissibleAlert = true;
      });
    },

    saveLendingLoanEditDash(bvModalEvt) {
      bvModalEvt.preventDefault();
      let promise = apis.saveLendingLoanDetails(this.editLendingLoanForm);
      promise.then((response) => {
        if (response.status == 200) {
          this.alertText = "Lending Loan Details Updated Successfully";
          this.variant = "success";
          this.showDismissibleAlert = true;
          this.$refs["editLendingLoanModal"].hide();
        } else {
          this.modalAlert = { show: true, text: "Error: " + this.getApiErrorText(response, "Unable to update lending loan details."), variant: "danger" };
        }
      }).catch((err) => {
        this.modalAlert = { show: true, text: "Error: " + this.getApiErrorText(err, "Unable to update lending loan details."), variant: "danger" };
      });
    },

    loadCaste() {
      apis.getCaste().then((r) => {
        if (r.status == 200) this.Caste = r.body;
      }).catch(() => {});
      apis.getStates().then((r) => {
        if (r.status == 200) this.addrStates = r.body;
      }).catch(() => {});
    },

    onAddrStateChange(stateId) {
      this.addrDistricts = [];
      this.addrTalukas = [];
      this.editAddressForm.CorrespondenceAddress.DistrictID = "";
      this.editAddressForm.CorrespondenceAddress.TalukaID = "";
      if (stateId) {
        apis.getDistricts(stateId).then((r) => {
          if (r.status == 200) this.addrDistricts = r.body;
        }).catch(() => {});
      }
    },

    onAddrDistrictChange(districtId) {
      this.addrTalukas = [];
      this.editAddressForm.CorrespondenceAddress.TalukaID = "";
      if (districtId) {
        apis.getTaluka(districtId).then((r) => {
          if (r.status == 200) this.addrTalukas = r.body;
        }).catch(() => {});
      }
    },

    getUserProfile() {
      var userinfo = this.$store.getters.loggedUser;
      let promiseU = apis.ReadUserDetailByIndivisual(userinfo.UserId);

      promiseU
        .then((response) => {
          if (response.status == 200) {
            //Check the profile completion status
            let rspns = response.body;
            this.fullPersonalDetails = response.body;
            this.AadharId = response.body.AdharNo;
            // Construct full name from available name fields
            let fullName = '';
            if (response.body.FirstName || response.body.MiddleName || response.body.LastName) {
              fullName = [response.body.FirstName, response.body.MiddleName, response.body.LastName]
                .filter(name => name)
                .join(' ');
            } else {
              fullName = response.body.Name || response.body.FullName || '';
            }
            this.ApplicantName = fullName;
            this.MobileNo = response.body.MobileNo;
            this.personalDetails.UserDocuments.PhotoPath =
              response.body.UserLoanDocuments.PhotoPath;
            if (rspns.LoanApplication.length == 1) {
              if (
                rspns.LoanApplication[0].LoanApplicationID ==
                "00000000-0000-0000-0000-000000000000"
              ) {
                this.LoanApplication = [];
              } else {
                this.LoanApplication = response.body.LoanApplication;
              }
            } else {
              this.LoanApplication = response.body.LoanApplication;
            }

            if (response.body.LoanApplication.length > 0) {
              // if (response.body.LoanApplication[0].LoanType > 0) {
              //   this.LoanApplication = response.body.LoanApplication;
              //   if (
              //     this.LoanApplication.LoanApplicationID !== undefined &&
              //     this.LoanApplication.LoanApplicationID !== ""
              //   ) {
              //     this.isViewEnabled = true;
              //   }
              //   if (
              //     this.LoanApplication.LoanApplicationID == undefined &&
              //     this.LoanApplication.LoanApplicationID == ""
              //   ) {
              //     this.isViewEnabled = true;
              //   }
              // }
              for (var i = 0; i < response.body.LoanApplication.length; i++) {
                const loan = response.body.LoanApplication[i];
                const hasAppNo =
                  loan.LoanApplicationNo !== undefined &&
                  loan.LoanApplicationNo !== "";

                if (hasAppNo && (loan.LoanType == 1 || loan.LoanType == 3)) {
                  this.AckPNo = loan.LoanApplicationNo;
                  this.$store.dispatch("setApplicationNo", this.AckPNo);
                  this.$store.dispatch("setApplicationID", loan.LoanApplicationID);
                  this.$store.dispatch("setAppStatus", loan.ApplicationStatus);
                  this.isViewEnabledP = true;
                  this.hasIndividualLoan = true;

                  if (loan.ApplicationStatus != 3) {
                    this.$store.dispatch("lockProfile", true);
                  }
                } else if (hasAppNo && loan.LoanType == 2) {
                  this.AckGNo = loan.LoanApplicationNo;
                  this.$store.dispatch("setApplicationNo", this.AckGNo);
                  this.$store.dispatch("setApplicationID", loan.LoanApplicationID);
                  this.$store.dispatch("setAppStatus", loan.ApplicationStatus);
                  this.isViewEnabledG = true;

                  if (loan.ApplicationStatus != 3) {
                    this.$store.dispatch("lockProfile", true);
                  }
                } else {
                  this.$store.dispatch("lockProfile", false);
                }
              }
            }
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch((err) => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    getSchemes() {
      let promise = apis.getSchemes();

      promise
        .then((response) => {
          if (response.status == 200) {
            let rspns = response.body;
            //this.$store.dispatch("setSchemeList", rspns);
            this.schemes = response.body;
          } else {
            this.alertText = "Unable to Load Scheme List, " + response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.alertText = "Unable to Load Scheme List, " + err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    getNoticeClaimId(notice) {
      if (!notice || typeof notice !== "object") return null;

      return (
        notice.ClaimEMIID ||
        notice.ClaimID ||
        notice.ClaimEmiId ||
        notice.ClaimEmiID ||
        null
      );
    },
    getClaimStatusText(item) {
      if (!item) return "";
      return (
        (item.ClaimStatus || item.Status || "")
          .toString()
          .trim()
          .toLowerCase()
      );
    },
    isRejectedLikeStatus(statusText) {
      if (!statusText) return false;
      return (
        statusText.indexOf("reject") !== -1 ||
        statusText.indexOf("send back") !== -1 ||
        statusText.indexOf("returned") !== -1 ||
        statusText.indexOf("return") !== -1 ||
        statusText.indexOf("not approved") !== -1
      );
    },
    toComparableDateKey(value) {
      if (!value) return null;

      if (value instanceof Date && !isNaN(value.getTime())) {
        return [
          value.getFullYear(),
          ("0" + (value.getMonth() + 1)).slice(-2),
          ("0" + value.getDate()).slice(-2)
        ].join("-");
      }

      var raw = value.toString().trim();
      if (!raw) return null;

      var parsed = new Date(raw);
      if (!isNaN(parsed.getTime())) {
        return [
          parsed.getFullYear(),
          ("0" + (parsed.getMonth() + 1)).slice(-2),
          ("0" + parsed.getDate()).slice(-2)
        ].join("-");
      }

      var cleaned = raw.replace(/,/g, "").replace(/\s+/g, "-");
      var match = cleaned.match(/(\d{1,2})[-\/.]([A-Za-z]{3}|\d{1,2})[-\/.](\d{2,4})/);
      if (!match) return null;

      var day = parseInt(match[1], 10);
      var monthToken = match[2].toLowerCase();
      var year = parseInt(match[3], 10);

      if (year < 100) year += 2000;

      var monthMap = {
        jan: 1,
        feb: 2,
        mar: 3,
        apr: 4,
        may: 5,
        jun: 6,
        jul: 7,
        aug: 8,
        sep: 9,
        oct: 10,
        nov: 11,
        dec: 12
      };

      var month = monthMap[monthToken] || parseInt(monthToken, 10);
      if (!day || !month || !year) return null;

      return [
        year,
        ("0" + month).slice(-2),
        ("0" + day).slice(-2)
      ].join("-");
    },
    extractNoticeClaimDateKey(notice) {
      if (!notice) return null;

      var header = (notice.Header || "").toString();
      var headerMatch = header.match(/(\d{1,2}[-\/.][A-Za-z]{3}[-\/.]\d{2,4}|\d{1,2}[-\/.]\d{1,2}[-\/.]\d{2,4}|\d{4}[-\/.]\d{1,2}[-\/.]\d{1,2})/);
      if (headerMatch && headerMatch[1]) {
        return this.toComparableDateKey(headerMatch[1]);
      }

      return this.toComparableDateKey(
        notice.EMIPaidDate || notice.ClaimDate || notice.Date || notice.RemarkDate
      );
    },
    extractClaimPaidDateKey(claim) {
      if (!claim) return null;
      return this.toComparableDateKey(
        claim.EMIPaidDate ||
          claim.EMIDate ||
          claim.ClaimDate ||
          claim.Date ||
          claim.CreatedDate
      );
    },
    filterResolvedClaimNotices(notices, claims) {
      if (!Array.isArray(notices) || !notices.length) return [];
      if (!Array.isArray(claims) || !claims.length) return notices;

      var claimStatusById = {};
      var claimStatusByDate = {};

      claims.forEach((claim) => {
        var statusText = this.getClaimStatusText(claim);
        var isRejected = this.isRejectedLikeStatus(statusText);
        var claimId =
          claim.ClaimEMIID ||
          claim.ClaimID ||
          claim.ClaimEmiId ||
          claim.ClaimEmiID ||
          null;

        if (claimId) {
          claimStatusById[claimId] = isRejected;
        }

        var dateKey = this.extractClaimPaidDateKey(claim);
        if (!dateKey) return;

        if (!claimStatusByDate[dateKey]) {
          claimStatusByDate[dateKey] = {
            hasRejected: false,
            hasNonRejected: false
          };
        }

        if (isRejected) {
          claimStatusByDate[dateKey].hasRejected = true;
        } else {
          claimStatusByDate[dateKey].hasNonRejected = true;
        }
      });

      return notices.filter((notice) => {
        if (!this.canOpenNoticeClaim(notice)) {
          return true;
        }

        var noticeClaimId = this.getNoticeClaimId(notice);
        if (noticeClaimId && Object.prototype.hasOwnProperty.call(claimStatusById, noticeClaimId)) {
          return claimStatusById[noticeClaimId];
        }

        var noticeDateKey = this.extractNoticeClaimDateKey(notice);
        if (!noticeDateKey || !claimStatusByDate[noticeDateKey]) {
          return true;
        }

        var dateStatus = claimStatusByDate[noticeDateKey];
        if (dateStatus.hasNonRejected && !dateStatus.hasRejected) {
          return false;
        }

        return true;
      });
    },
    canOpenNoticeClaim(notice) {
      if (!notice) return false;

      var text = (
        (notice.Header || "") + " " +
        (notice.Subheader || "") + " " +
        (notice.RejectRemarks || "")
      ).toLowerCase();

      return (
        text.indexOf("not approved") !== -1 ||
        text.indexOf("reject") !== -1 ||
        text.indexOf("send back") !== -1 ||
        text.indexOf("return") !== -1
      );
    },
    openNoticeClaim(notice) {
      var claimId = this.getNoticeClaimId(notice);
      if (claimId) {
        this.$router.push({
          path: "/claimupload",
          query: { claimId: claimId }
        });
        return;
      }

      this.$router.push("/claims");
    },
  },
  mounted() {
    this.schemes = [];
    var userinfo = this.$store.getters.loggedUser;
    this.getSchemes();
    this.getUserProfile();
    this.loadCaste();

    Promise.allSettled([
      apis.readNotifications(userinfo.UserId),
      apis.readClaims(userinfo.UserId)
    ])
      .then((results) => {
        var noticeResponse = results[0] && results[0].status === "fulfilled" ? results[0].value : null;
        var claimsResponse = results[1] && results[1].status === "fulfilled" ? results[1].value : null;

        var notices = noticeResponse && noticeResponse.status == 200 && Array.isArray(noticeResponse.body)
          ? noticeResponse.body
          : [];
        var claims = claimsResponse && claimsResponse.status == 200 && Array.isArray(claimsResponse.body)
          ? claimsResponse.body
          : [];

        this.notices = this.filterResolvedClaimNotices(notices, claims);
      })
      .catch((err) => {
        console.err(err);
      });
  },
};
</script>

<style scoped>
.body-wrapper {
  margin-top: 20px;
  padding-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  border: solid thin #ccc;
  -webkit-box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
  -moz-box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
  box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
}

.body-title {
  padding: 15px 25px;
  background: #fff;
  border-bottom: solid 1px #d3d3d3;
}

.body-content {
  padding: 25px 10px;
}

/* Akshay 25-08-2019 */

.dash-heading {
  color: #000;
  font-weight: bold;
  font-size: 19px;
}

.body-content {
  padding-left: 25px;
  padding-right: 25px;
}
.body-wrapper {
  box-shadow: none;
  -webkit-box-shadow: none;
  padding-bottom: 0;
  margin-top: 30px;
  margin-bottom: 30px;
}

.dash-btn {
  color: #fff;
  background-color: #0A0032;
  font-size: 11px;
  padding: 7px 20px;
  border-radius: 4px;
  font-weight: bold;
  margin-bottom: 3px;
  margin-top: 3px;
}

.dash-table-1 {
  margin-bottom: 30px;
}
.dash-divider {
  margin-top: 20px;
  margin-bottom: 20px;
  height: 1px;
  border-bottom: 1px solid #f2f2f2;
}
.dash-sec-heading {
  color: #000;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
}

.dash-table-2-row {
  margin-bottom: 30px !important;
  margin-top: 20px;
}

.dash-table-2-row .form-control {
  font-size: 12px;
  padding-top: 8px;
  padding-bottom: 8px;
}

.dash-table-2-row .custom-select {
  padding-top: 8px;
  padding-bottom: 8px;
  height: auto;
  font-size: 12px;
}

.custom-select:disabled {
  background-color: #6c757d;
  color: #fff;
  border: none;
  opacity: 0.65;
}
.dash-table-2-row button {
  padding-left: 20px;
  padding-right: 20px;
}

.dash-pagination-row {
  margin-top: 20px;
}

.dash-pagination-row .page-item.active .page-link {
  background-color: #0A0032;
  border-color: #0A0032;
  padding-right: 10px;
  padding-left: 10px;
}

.color-btn {
  margin-top: 3px;
  margin-bottom: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue